/**
 * Keys read by the components shared with Funeral Manager (addf-package,
 * BaseFormComponent, SelectAjax…). Funeral Manager gets them from its API;
 * Crema ships them here. Merged into each locale without overriding Crema's
 * own translations (see src/i18n.js).
 */
export default {
  fr_BE: {
    enums: {
      activityLog: {
        type: {
          created: 'création',
          updated: 'modification',
          deleted: 'suppression',
          restored: 'restauration'
        }
      }
    },
    toasts: {
      this_permission_is_linked_to_role:
        "cette permission vient d'un rôle de l'utilisateur"
    },
    attributes: {
      users: 'utilisateurs',
      empty: 'vide',
      link_url: 'URL du lien',
      outstanding_balance: 'reste à percevoir',
      products: 'produits',
      total_hors_debours: 'total hors débours',
      vat_distribution: 'répartition TVA'
    },
    button: {
      clear_all: 'tout effacer',
      apply: 'appliquer',
      column: 'colonnes',
      insert_link: 'insérer un lien',
      remove_link: 'retirer le lien'
    },
    global: {
      system: 'système',
      activity_log: 'registre',
      other_languages_have_content: "d'autres langues ont un contenu",
      all: 'tous',
      aucun_selectionne: 'aucun sélectionné',
      aucun_selectionne_f: 'aucune sélectionnée',
      date: 'date',
      filters: 'filtres',
      items: 'articles',
      is_empty_list: 'la liste est vide',
      no_result_found: 'aucun résultat',
      search_failed: 'la recherche a échoué',
      search_min_chars: 'tapez au moins 3 caractères',
      no_tag: 'aucun tag',
      none: 'aucun',
      period_label: 'période',
      select: 'sélectionner',
      selectionnes: 'sélectionnés',
      taper_qq: 'tapez quelques lettres pour rechercher',
      time: 'heure',
      unit_price: 'prix unitaire',
      wysiwyg_image_added: 'image ajoutée',
      wysiwyg_image_invalid_type: "ce type de fichier n'est pas une image",
      wysiwyg_image_resized: "l'image a été redimensionnée",
      wysiwyg_image_unreadable: "l'image n'a pas pu être lue",
      wysiwyg_image_upload_failed: "l'envoi de l'image a échoué"
    }
  },
  nl_BE: {
    enums: {
      activityLog: {
        type: {
          created: 'aanmaak',
          updated: 'wijziging',
          deleted: 'verwijdering',
          restored: 'herstel'
        }
      }
    },
    toasts: {
      page_not_allowed: 'u hebt geen toegang tot deze pagina',
      send_invoice_fields_required:
        'vul de ontvangers, het onderwerp en het bericht in',
      this_permission_is_linked_to_role:
        'deze machtiging komt van een rol van de gebruiker'
    },
    attributes: {
      users: 'gebruikers',
      empty: 'leeg',
      link_url: 'link-URL',
      outstanding_balance: 'nog te ontvangen',
      products: 'producten',
      total_hors_debours: 'totaal exclusief voorschotten',
      vat_distribution: 'btw-verdeling'
    },
    button: {
      clear_all: 'alles wissen',
      apply: 'toepassen',
      column: 'kolommen',
      insert_link: 'link invoegen',
      remove_link: 'link verwijderen'
    },
    global: {
      page_not_found: 'pagina niet gevonden',
      page_not_found_description:
        'Deze pagina bestaat niet of is verplaatst. Controleer het adres of ga terug naar de lopende dossiers.',
      system: 'systeem',
      activity_log: 'register',
      other_languages_have_content: 'andere talen hebben een inhoud',
      all: 'alle',
      aucun_selectionne: 'niets geselecteerd',
      aucun_selectionne_f: 'niets geselecteerd',
      date: 'datum',
      filters: 'filters',
      items: 'artikelen',
      is_empty_list: 'de lijst is leeg',
      no_result_found: 'geen resultaten',
      search_failed: 'zoeken mislukt',
      search_min_chars: 'typ minstens 3 tekens',
      no_tag: 'geen tag',
      none: 'geen',
      period_label: 'periode',
      select: 'selecteren',
      selectionnes: 'geselecteerd',
      taper_qq: 'typ enkele letters om te zoeken',
      time: 'uur',
      unit_price: 'eenheidsprijs',
      wysiwyg_image_added: 'afbeelding toegevoegd',
      wysiwyg_image_invalid_type: 'dit bestand is geen afbeelding',
      wysiwyg_image_resized: 'de afbeelding werd verkleind',
      wysiwyg_image_unreadable: 'de afbeelding kon niet gelezen worden',
      wysiwyg_image_upload_failed: 'het uploaden van de afbeelding is mislukt'
    }
  }
}
